import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('PARTNER_OFFER_BY_PARTNER_LIST');
